module.exports = __webpack_public_path__ + "img/9788961702331.0828fd54.jpg";